import { InputTextType } from "../Enum/InputTextType";
import { Utils } from "../Utils/Utils";
import Control from "./Control";
export default class InputTextControl extends Control {
    constructor(field, isMain = true, pattern = null) {
        super(field);
        this.type = InputTextType.text;
        this.pattern = null;
        this.isMain = true;
        this.isMain = isMain;
        this.pattern = pattern;
    }
    afterRender() {
        // Setup parent-child relation if parent field is specified
        this.setupParentChildRelation();
        super.afterRender();
    }
    renderField() {
        if (this.field.isMultilineText) {
            return `<textarea \
            ${this.isMain ? " data-main" : ""}\
            type=${this.type} \
            ${this.pattern ? "pattern='" + this.pattern + "'" : ""}\
            id=${this.field.internalId}${this.isRequired() ? " required" : ""} \
            placeholder="${Utils.isOk(this.field.placeHolder) ? this.field.placeHolder : ""}">${this.initialValue ? this.initialValue : ""}</textarea>`;
        }
        else {
            return `<input \
            ${this.isMain ? " data-main" : ""}\
            type=${this.type} \
            ${this.pattern ? "pattern='" + this.pattern + "'" : ""}\
            id=${this.field.internalId}${this.isRequired() ? " required" : ""} \
            value="${this.initialValue ? this.initialValue : ""}"
            placeholder="${Utils.isOk(this.field.placeHolder) ? this.field.placeHolder : ""}"/>`;
        }
    }
    /**
     * Update field required attribute and its related design
     * @param isFieldRequired
     */
    updateFieldRequiredAttribute(isFieldRequired) {
        const fieldControl = (document.querySelector(`#control_${this.field.internalId}`));
        const inputElement = (document.getElementById(`${this.field.internalId}`));
        const inputLabelElement = (fieldControl.querySelector("label"));
        const inputLabelRequiredElement = (inputLabelElement.querySelector('span'));
        // reset required atrribute and design
        fieldControl.classList.remove('not-valid');
        inputElement.required = false;
        this.field.isRequired.staticValue = false;
        if (inputLabelRequiredElement) {
            inputLabelRequiredElement.remove();
        }
        if (isFieldRequired) {
            inputLabelElement.innerHTML += "<span class=required>*</span>";
            inputElement.required = true;
            this.field.isRequired.staticValue = true;
        }
    }
    /**
     * Setup parent-child elements relationship (between a select parent element and input text child element)
     * Listens to parent field changes and manage this control accordingly
     */
    setupParentChildRelation() {
        var _a, _b, _c;
        const parentFieldId = (_a = this.field.inputTextFieldSettings) === null || _a === void 0 ? void 0 : _a.parentFieldInternalId;
        if (!parentFieldId) {
            return; // No parent field specified
        }
        // show field on first load if it has a parent field
        this.hide();
        // Find the parent field
        const parentField = (_c = (_b = this.field.form) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.find(f => f.internalId === parentFieldId);
        if (!parentField || !parentField.control) {
            console.warn(`Parent field with ID "${parentFieldId}" not found for input text control "${this.field.internalId}"`);
            return;
        }
        // Get the parent control's select element (only select control can have effect on textbox)
        const parentSelectElement = document.querySelector(`#control_${parentFieldId} select`);
        if (!parentSelectElement) {
            console.warn(`Parent select element not found for field "${parentFieldId}"`);
            return;
        }
        // Initial filter based on current parent value
        const initialParentValue = parentSelectElement.value;
        if (initialParentValue) {
            const isDescendentRequired = this.isSelectedOptionHasDescendentRequired(parentSelectElement);
            this.updateFieldRequiredAttribute(isDescendentRequired);
        }
        // Listen to parent field changes
        parentSelectElement.addEventListener('change', () => {
            const isDescendentRequired = this.isSelectedOptionHasDescendentRequired(parentSelectElement);
            this.updateFieldRequiredAttribute(isDescendentRequired);
        });
    }
    /**
     * Check if selected option should have the descendent element required
     * @param selectElement the select element
     * @returns
     */
    isSelectedOptionHasDescendentRequired(selectElement) {
        // Get the selected option element
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        // Read the data-descendent-required attribute
        const isDescendentRequired = selectedOption.dataset.descendentRequired == "true";
        return isDescendentRequired;
    }
}
